import bookingService from '../../components/Booking-new/services/BookingService';

const getLocationsTimeSlotsInfo = async (locations, serviceCode) => {
  try {
    const response = await bookingService.getLocationsAvailableSlotsInfo(serviceCode);
    if (!response.error && !!response.data) {
      const availableSlotsInfo = response.data;
      return locations.map(location => {
        const foundLocation = availableSlotsInfo.find(a => a.shopCode === location.code);
        return {
          ...location,
          service: {
            ...location.service,
            noOfAvailableSlots: foundLocation.availableSlots || 0,
          },
        };
      });
    } else {
      console.error('Something went wrong while fetching the timeslots info for locations');
      return locations;
    }
  } catch (e) {
    console.error('Error occured while fetching timeslots info for locations', e);
    return locations;
  }
};

export { getLocationsTimeSlotsInfo };
